import { cachiosInstance } from "./cacheApi";

/**
 * ----------------------------
 *  Investor routes
 * ----------------------------
 */

export const getInvestor = (query, force = false, callback) => {
    cachiosInstance.get(`/investor?${query}`, { force })
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
